import { useMutation } from "@apollo/client";
import { useState } from "react";
import { logGqlErrorToSentry } from "utils/sentry";

import CREATE_CAMPAIGN from "../queries/createCampaign.gql";

const useCreateCampaign = () => {
  const [error, setError] = useState();
  const [campaignId, setCampaignId] = useState();
  const [createCampaign, { loading }] = useMutation(CREATE_CAMPAIGN, { errorPolicy: "all" });

  return {
    createCampaign: (input) => {
      createCampaign({ variables: { input } })
        .then((result) => {
          if (result.errors?.length) {
            logGqlErrorToSentry(result.errors[0], "Onboarding: Could not create campaign", {
              storage_data: JSON.parse(localStorage.getItem("onBoarding")) ?? [],
              form_data: input,
            });
            setError(result.errors[0]);

            return;
          }

          setCampaignId(result.data?.createCampaign?.campaign.id);
        });
    },
    campaignId,
    loading,
    location,
    error,
  };
};

export default useCreateCampaign;
